import { CellItemAuth } from '@/types/pages/buttonClickAuth'
import { UseRouter } from '@/hooks/useRouter'
import { assetsApi, chromaticsTableApi } from '@/service'
import { DiaLogType } from '@/types'
import { useCommonStore } from '@/store'

export class CommonUrl {
  static Price_Up =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/08755ea0-1a3b-4e2a-89e9-cfc42c812455.png'

  static Price_Down =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/b4fe63d4-8b62-451f-978c-612badf4dfa3.png'

  static Sell_Business =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/fb4cf879-025c-4d78-94dc-28e56c681159.png'

  static Anti_Money_Laundering =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/ca277e50-5caf-4d02-8c6c-4943f13c1714.png'

  static Diamond_Recycle =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/7957de95-0a43-44a2-a4c3-654a01f8cb8b.png'

  static Yi_Dian_Jin =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/be327187-7598-4c75-8f04-a9dbcdf92fe9.png'

  static Help_Zxj_Sell_gold =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/037c051f-b98c-4987-9e54-709e040286f9.png'

  static None_Data_Logo =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/04/feed1142-c6a1-4be3-b28f-fb75d11d2fab.png'

  static Company_Logo =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/f3624ab2-0ea3-4ffa-a719-866bd3fbd54f.png'

  static Company_Logo_Slogan =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/a76edfba-f8fd-457b-8a38-05c3e18326fb.png'

  static TabBar_TopBg =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/7a33359e-de62-4cce-b9a0-0921cc0d544a.png'

  static My_Service_Icon =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/09ed0007-b855-445b-a124-11630c7b6aad.svg'

  static My_Setting_Icon =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/335e274d-77af-4958-90ae-5244c4266ef3.png'

  static User_HeadPortrait =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/fb43d101-0313-4093-a2ad-0055ef303095.png'

  static NoneLogin_HeadPortrait =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/139be820-4e7d-4d14-b155-66218775ac52.png'

  static My_Order_Center = [
    {
      type: 'incoming',
      title: '来料订单',
      icon: 'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/b99e795e-2839-4f78-a275-092509b8467f.png',
      router: UseRouter.INCOMING_ORDER_URL,
      auth: [
        CellItemAuth.LOGIN,
        CellItemAuth.CERTIFICATION,
        CellItemAuth.SIGN_AGREEMENT,
        CellItemAuth.CONTRACT,
      ],
    },
    {
      type: 'sellMaterials',
      title: '卖料订单',
      icon: 'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/01c76c6e-a9c5-4ae4-bf71-53bc4a5f1084.png',
      router: UseRouter.ORDER_SELL_ORDER_URL,
      auth: [
        CellItemAuth.LOGIN,
        CellItemAuth.CERTIFICATION,
        CellItemAuth.SIGN_AGREEMENT,
        CellItemAuth.CONTRACT,
      ],
    },
    {
      type: 'stockMaterials',
      title: '存料订单',
      icon: 'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/4cb3562f-bda9-4ca3-a096-91e4e410533d.png',
      router: '',
      auth: [
        CellItemAuth.LOGIN,
        CellItemAuth.CERTIFICATION,
        CellItemAuth.SIGN_AGREEMENT,
        CellItemAuth.CONTRACT,
      ],
    },
    {
      type: 'purification',
      title: '提纯订单',
      icon: 'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/3057772b-7917-45fd-86fe-6aaa85b09e5d.png',
      router: '',
      auth: [
        CellItemAuth.LOGIN,
        CellItemAuth.CERTIFICATION,
        CellItemAuth.SIGN_AGREEMENT,
        CellItemAuth.CONTRACT,
      ],
    },
  ]

  static My_Common_tools = [
    {
      type: 'deliverGoods',
      title: '顺丰发货',
      icon: 'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/dd60f900-5fe2-46ac-a300-2bd4eb37e5a7.png',
      router: UseRouter.ORDER_EXPRESS_INSURANCE_URL,
      backEvent: async () => {
        const commonStore = useCommonStore()
        commonStore.setExpressInsureActiveKey('delivery')
      },
      auth: [
        CellItemAuth.LOGIN,
        CellItemAuth.CERTIFICATION,
        CellItemAuth.SIGN_AGREEMENT,
        CellItemAuth.CONTRACT,
      ],
    },
    {
      type: 'insurance',
      title: '物流保险',
      icon: 'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/03d2f61b-0967-4108-a84c-f7f46078f09b.png',
      router: UseRouter.ORDER_EXPRESS_INSURANCE_URL,
      backEvent: async () => {
        const commonStore = useCommonStore()
        commonStore.setExpressInsureActiveKey('insure')
      },
      auth: [
        CellItemAuth.LOGIN,
        CellItemAuth.CERTIFICATION,
        CellItemAuth.SIGN_AGREEMENT,
        CellItemAuth.CONTRACT,
      ],
    },
    {
      type: 'warn',
      title: '价格提醒',
      icon: 'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/65ddf407-84bf-4b40-afaa-556a239537dd.png',
      router: UseRouter.ORDER_REMIND_URL,
      auth: [
        CellItemAuth.LOGIN,
        CellItemAuth.CERTIFICATION,
        CellItemAuth.SIGN_AGREEMENT,
        CellItemAuth.CONTRACT,
      ],
    },
    {
      type: 'contract',
      title: '合同单据',
      icon: 'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/6379cb2a-1e38-4380-b18f-39c6b8218870.png',
      router: UseRouter.PAGE_CONTRACT_DOCUMENT_URL,
      auth: [
        CellItemAuth.LOGIN,
        CellItemAuth.CERTIFICATION,
        CellItemAuth.SIGN_AGREEMENT,
        CellItemAuth.CONTRACT,
      ],
    },
  ]

  static My_About_Me = [
    {
      type: 'recoveryStandard',
      title: '回收标准',
      icon: 'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/e307eb26-8a2d-4db2-b5e4-ccb161511aed.png',
      router: UseRouter.PAGE_COMMON_PICTURE_PRESENTATION_URL,
      backEvent: async () => {
        const res = await chromaticsTableApi()
        const dialog = res.filter((item) => item.eventType === DiaLogType.RECYCLE_COLOR)
        if (dialog.length > 0) {
          const commonStore = useCommonStore()
          commonStore.setCommonPicturePresentationModel({
            title: '成色表',
            url: [dialog[0].img],
            type: 'convention',
          })
        }
      },
      auth: [
        CellItemAuth.LOGIN,
        CellItemAuth.CERTIFICATION,
        CellItemAuth.SIGN_AGREEMENT,
        CellItemAuth.CONTRACT,
      ],
    },
    {
      type: 'commonProblem',
      title: '常见问题',
      icon: 'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/7c3d165d-b19a-4667-b2ed-c28839dbd63e.png',
      router: UseRouter.PAGE_COMMON_PROBLEM_URL,
      auth: [
        CellItemAuth.LOGIN,
        CellItemAuth.CERTIFICATION,
        CellItemAuth.SIGN_AGREEMENT,
        CellItemAuth.CONTRACT,
      ],
    },
    // {
    //   type: 'announcement',
    //   title: '企业公告',
    //   icon: 'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/af6082d0-fa75-49f9-aa13-183062c5e70b.png',
    //   router: UseRouter.PAGE_COMMON_PICTURE_PRESENTATION_URL,
    //   backEvent: async () => {
    //     const commonStore = useCommonStore()
    //     commonStore.setCommonPicturePresentationModel({
    //       title: '企业公告',
    //       url: ['https://shop.beijingzxj.com/bank_list'],
    //       type: 'webview',
    //     })
    //   },
    //   auth: [
    //     CellItemAuth.LOGIN,
    //     CellItemAuth.CERTIFICATION,
    //     CellItemAuth.SIGN_AGREEMENT,
    //     CellItemAuth.CONTRACT,
    //   ],
    // },
    {
      type: 'business',
      title: '业务说明',
      icon: 'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/56aeed62-3c17-47b0-b597-2b9b89f7d470.png',
      router: UseRouter.PAGE_COMMON_PICTURE_PRESENTATION_URL,
      backEvent: async () => {
        const commonStore = useCommonStore()
        const res = await assetsApi()
        commonStore.setCommonPicturePresentationModel({
          title: '业务说明',
          url: [res.BUSINESS_DESCRIPTION],
          type: 'convention',
        })
      },
      auth: [
        CellItemAuth.LOGIN,
        CellItemAuth.CERTIFICATION,
        CellItemAuth.SIGN_AGREEMENT,
        CellItemAuth.CONTRACT,
      ],
    },
    {
      type: 'about',
      title: '关于我们',
      icon: 'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/20bb4dcf-1352-4386-a136-0fc3a09b1502.png',
      router: UseRouter.PAGE_ABOUT_URL,
      auth: [
        CellItemAuth.LOGIN,
        CellItemAuth.CERTIFICATION,
        CellItemAuth.SIGN_AGREEMENT,
        CellItemAuth.CONTRACT,
      ],
    },
    // {
    //   type: 'agreement',
    //   title: '用户协议',
    //   icon: 'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/1d64c8cc-4553-4338-929b-d0022719997b.png',
    //   router: UseRouter.PAGE_USER_AGREEMENT_URL,
    //   auth: [
    //     CellItemAuth.LOGIN,
    //     CellItemAuth.CERTIFICATION,
    //     CellItemAuth.SIGN_AGREEMENT,
    //     CellItemAuth.CONTRACT,
    //   ],
    // },
  ]

  static Service_Cell_Head =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/6c89f410-f0c4-406a-94a7-43c053541c4f.png'

  static Service_Cell_Wx =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/fb5ef46f-3754-4e4d-b534-11e46693c497.png'

  static Service_Cell_Phone =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/2f9ae819-b5a3-4677-92fd-c1d246c422f9.png'

  static Address_Cell_Edit_Icon =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/25373373-1e27-43af-9778-27d16782d4c7.png'

  static Address_Cell_Del_Icon =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/3bf877c3-2f37-4f32-850d-f500f8670485.png'

  static Bank_AddBtn_Icon =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/c82bda8b-f994-4533-a148-1f238ae8fa5c.svg'

  static Bank_Cell_Logo =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/6a636827-61cb-4baa-8720-cbf50cfe7f59.svg'

  static Auth_Portrait_Img =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/48c4bc8d-a94a-4598-bb8b-bd9502095718.png'

  static Auth_National_Img =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/2b720f66-4e56-48c5-8da8-251d0e5a098e.png'

  static Auth_Update_Img =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/4bedf93c-9a0c-482c-907e-6814cda6e800.png'

  static Success_Page_Img =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/02/28ea3e52-b279-4f7e-9375-110f4748f7f5.png'

  static Deposit_Top_Img =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/03/6ce4a421-e736-4ae4-8f6e-d8516e3e297d.png'

  static Incoming_Cell_Status_Finish_Img =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/11/6d8aa6bb-60ca-4657-b3c4-e6510016171e.png'

  static Incoming_Cell_Status_None_Img =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/11/fe12e8fc-72f3-475e-8785-734ecc8337a9.png'

  static Incoming_Cell_Arrow_Img =
    'https://zxj-common.oss-cn-shenzhen.aliyuncs.com/2025/11/bd5df6ac-08de-41d5-b632-a541c504be1e.png'
}
